module.exports = __webpack_public_path__ + "static/img/image12.0a0b9d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instruction_images/image12.png
// module id = e/pu
// module chunks = 0